'use strict';
const trackingUtils = require('../../utils/tracking.utils');
const insuranceCatalogue = require('../../collections/insurance_catalogue.collection');
const MODULE = 'flightsummary';
const RESULTS_PAGE = 'results';
const DYNPACK_PRODUCT = 'dp';
const FLIGHTS_PRODUCT = 'fl';
const CONDITIONS_URL = 'conditionsUrl';
const CONDITIONS_URL_EXTENDED = 'conditionsUrlExtended';
const DRAWER_TRACKING_ACTION = 'ancillary_information';
const PAGES_TO_TRACK = {
    results: 'res',
    details: 'pax',
    flightsummary: 'sum',
    flightinfo: 'info',
    payment: 'pay',
};

module.exports = Backbone.View.extend({

    events: {
        'mousedown .conditions_link': 'onConditionsLinkClick',
        'tap .open_drawer_insurance': 'clickOpenDrawerInformation',
    },

    clickOpenDrawerInformation() {
        this.model.set('enabled', true);
    },

    onConditionsLinkClick() {
        const page = Odigeo.History.getPageNameFromFragment();
        const productPageIdentifier = this.getProductPageIdentifier();
        const step = PAGES_TO_TRACK[page] + productPageIdentifier;
        trackingUtils.trackEvent(DRAWER_TRACKING_ACTION, `ancillary_open_details_cat:HUB_pag:${step}`);
    },

    initialize(options) {
        this.options = options;
        this.keys = Odigeo._.clone(options.keys);
        Odigeo.Templates.getGenericTemplates([MODULE])
            .then(({flightsummary}) => {
                const {stopInfoHub, stopInfoItem} = flightsummary;
                this.template = stopInfoHub;
                this.renderHubStop({stopInfoItem});
            });
    },

    renderHubStop(options) {
        this.templateData = {
            stopInfoItem: options.stopInfoItem,
            insuranceHub: this.formatInsuranceLink(),
            keys: this.keys,
        };
        this.render();
    },

    render() {
        this.$el.html(this.template(this.templateData));
    },

    getProductPageIdentifier() {
        return Odigeo.Utils.isRequestApp(DYNPACK_PRODUCT) ? DYNPACK_PRODUCT : FLIGHTS_PRODUCT;
    },

    getInsuranceHubPolicyLink(hubInsurancePolicy) {
        const page = Odigeo.History.getPageNameFromFragment();
        const insurance = page === RESULTS_PAGE ?
            this.getInsuranceFromResults(hubInsurancePolicy) : this.getInsuranceFromShoppingCart(hubInsurancePolicy);
        const urlConditionsParsedProp = Odigeo._.isEmpty(insurance.conditionsUrlExtended) ? CONDITIONS_URL : CONDITIONS_URL_EXTENDED;
        return insurance[urlConditionsParsedProp];
    },

    getInsuranceFromResults(hubInsurancePolicy) {
        const {hubInsurance} = this.options;
        return !Odigeo._.isEmpty(hubInsurance) && (hubInsurance.policy === hubInsurancePolicy) ? hubInsurance : {};
    },

    getInsuranceFromShoppingCart(hubInsurancePolicy) {
        const insuranceCatalogueCollection = insuranceCatalogue.getInstance();
        return insuranceCatalogueCollection.isLoaded() ? insuranceCatalogueCollection.getInsuranceByPolicy(hubInsurancePolicy) : {};
    },

    formatInsuranceLink() {
        const {insuranceHub, policyDetails} = this.keys;
        const drawerLinkClass = Odigeo.AB.isNewTripDetails ? 'od-collapsible-drawer-link-v3' : 'od-collapsible-drawer-link';
        const linkClass = `odf-link-legal odf-link-sm prevent_toggle conditions_link ${drawerLinkClass}`;
        const insuranceLink = `<span class="${linkClass} open_drawer_insurance">${policyDetails}</span>`;
        return Odigeo.Utils.replaceCmsKeyArgs(insuranceHub, insuranceLink);
    },
});
